export const DEFAULT_BOOKING_ARRIVAL_TIME_PADDING = 10
export const DEFAULT_BOOKING_DEPARTURE_TIME_PADDING = 10
